export default __webpack_public_path__ + "static/media/Start_Still.f79cc368.jpg";